import React, { useState, useContext, useEffect } from "react";
import Help from "./Help";
import CongestionReport from "./Report";
import View from "common/View";
import SelectInputWithIcon from "common/SelectInputWithIcon";
import BqnContext from "common/BqnContext";
import { hoursScopeChoices } from "common/constants";
import styled from "styled-components";

const provideOptionValueNumberTo = method => event =>
  method(parseInt(event.target.value))

export const Button = styled.button`
  width: 138px;
  height: 25px;
  line-height: 13px;
`;

const CongestionSettings = ({hours, setHours, aggregateBqns, toogleAggregation}) =>  (
  < >
    {aggregateBqns === null ? null : (
      <Button
        type="button"
        className="btn btn-link waves-effect"
        onClick={toogleAggregation}
      >
        {aggregateBqns ? "Disaggregate BQNs" : "Aggregate BQNs"}
      </Button>
    )}
    <SelectInputWithIcon
      title="Date Range"
      name="Date Range"
      icon="date_range"
      selected={hours}
      onChange={provideOptionValueNumberTo(setHours)}
      options={hoursScopeChoices}
    />
  </>
);

const doesNothing = () => {}
const useAggregation = () => {
  const {
    bqnId,
    clusterStatus: { mode },
  } = useContext(BqnContext);
  console.warn({bqnId, mode})
  const [aggregateBqns, setAggregateBqns] = useState(mode === "standalone" || bqnId !== "all")
  const toogleAggregation = () => setAggregateBqns(previous => !previous);
  useEffect(() => {
    setAggregateBqns( previous => 
      bqnId === "all" && previous === true ? false :
      bqnId !== "all" && previous !== true ? true :
      previous // leave as it's
    )
  }, [bqnId]);
  return (mode === 'cluster' && bqnId === 'all') 
    ? [aggregateBqns, toogleAggregation]
    : [null, doesNothing]
}
const useCongestionSettings = ({defaultHours=24}={}) => {
  const [hours, setHours] = useState(defaultHours);
  const [aggregateBqns, toogleAggregation] = useAggregation();
  console.warn({aggregateBqns})
  return {hours, setHours, aggregateBqns, toogleAggregation }
}

const CongestionAndACM = ({returnView}) => {
  const settings = useCongestionSettings(); 
  return (
    <View
      title="Congestion & ACM Metrics"
      bodyPanelLayout="row contained"
      Help={Help}
      returnView={returnView}
      ContextMenuCustom={<CongestionSettings {...settings} />}
    >
      <CongestionReport {...settings} />
    </View>
  );
};

export default CongestionAndACM;
